import "core-js/modules/es6.object.assign";
import { useMemo, createElement } from 'react';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var getRibbonImageURL = function getRibbonImageURL(position, color) {
  if (color === void 0) {
    color = 'black';
  }

  switch (color) {
    case 'green':
      return "https://github.blog/wp-content/uploads/2008/12/forkme_" + position + "_green_007200.png?resize=149%2C149";

    case 'red':
      return "https://github.blog/wp-content/uploads/2008/12/forkme_" + position + "_red_aa0000.png?resize=149%2C149";

    case 'orange':
      return "https://github.blog/wp-content/uploads/2008/12/forkme_" + position + "_orange_ff7600.png";

    case 'grey':
      return "https://github.blog/wp-content/uploads/2008/12/forkme_" + position + "_gray_6d6d6d.png?resize=149%2C149";

    case 'white':
      return "https://github.blog/wp-content/uploads/2008/12/forkme_" + position + "_white_ffffff.png?resize=149%2C149";

    case 'black':
      return "https://github.blog/wp-content/uploads/2008/12/forkme_" + position + "_darkblue_121621.png?resize=149%2C149";

    default:
      var t;
      t = color;
      throw new Error('unsuported type' + t);
  }
};

var styleBase = {
  position: 'absolute',
  top: 0,
  right: 0,
  border: 0
};

var GitHubRibbon = function GitHubRibbon(props) {
  var color = props.color,
      style = props.style;
  var position = props.position || 'right';
  var src = useMemo(function () {
    return getRibbonImageURL(position, color);
  }, [position, color]);
  var ribbonStyle = useMemo(function () {
    var _extends2;

    return _extends({}, styleBase, (_extends2 = {}, _extends2[position] = 0, _extends2), style);
  }, [position, style]);
  return createElement("a", Object.assign({
    style: ribbonStyle
  }, props), createElement("img", {
    width: "149",
    height: "149",
    src: src,
    className: "attachment-full size-full",
    alt: "Fork me on GitHub",
    "data-recalc-dims": "1"
  }));
};

export default GitHubRibbon;
export { GitHubRibbon, getRibbonImageURL };